import styled from 'styled-components';

export const MetaWrapper = styled.div`
  color: black;
`;
